import { render, staticRenderFns } from "./ChangeLogBannerModal.vue?vue&type=template&id=95f7b116&"
import script from "./ChangeLogBannerModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLogBannerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports